export default __webpack_public_path__ + "static/media/pregnancy.4efa67ca.svg";